import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import type { ApiEntity } from '@backstage/catalog-model';

import { OpenApiPkceDefinition } from './components/apiDocs/OpenApiPkceDefinition';

// Override the api-docs plugin's `apiDocsConfigRef` (extension id
// `api:api-docs/config`) by declaring a module against pluginId 'api-docs' with
// the same `config` name — the module's extension replaces the plugin's.
//
// We keep every default widget except `openapi`, which we swap for a SwaggerUI
// renderer that enables Authorization Code + PKCE (the stock widget can't — see
// OpenApiPkceDefinition). iot-backstage #81.
export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    ApiBlueprint.make({
      name: 'config',
      params: defineParams =>
        defineParams({
          api: apiDocsConfigRef,
          deps: {},
          factory: () => {
            const widgets = defaultDefinitionWidgets().map(widget =>
              widget.type === 'openapi'
                ? {
                    ...widget,
                    component: (definition: string) => (
                      <OpenApiPkceDefinition definition={definition} />
                    ),
                  }
                : widget,
            );
            return {
              getApiDefinitionWidget: (apiEntity: ApiEntity) =>
                widgets.find(d => d.type === apiEntity.spec.type),
            };
          },
        }),
    }),
  ],
});
